import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, AangifteRapport, BokkzAlgDataService, IncomeTaxEntity,
  JaarrekeningVenW,
  OmschrijvingEnBedrag,
  Onderneming
} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-winstcorrecties',
  templateUrl: './winstcorrecties.component.html',
  styleUrls: ['./winstcorrecties.component.scss'],
  imports: [
    SharedUiButtonModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class WinstcorrectiesComponent implements OnInit , OnDestroy{
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte;

    public isDefAangifte ={} as boolean;

    private focusedElementId: string | null = null;
    public showSpinner = true;

    ondernemingFG: FormGroup;
    public winstResultatenrekeningFg = {} as FormGroup;
    public specJaarrekeningFg = {} as FormGroup
    public winstResultatenrekening = 0;
    public rapport = {} as AangifteRapport;

    constructor(private fb: FormBuilder, private router: Router,public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
        this.ondernemingFG = this.fb.group({
            ondernemingen: this.fb.array([]),
        });
        this.winstResultatenrekeningFg = this.fb.group({
            winstResultatenrekening: null as unknown as number,
        });
    }

    //onderneming
    get ondernemingen(): FormArray {
        return this.ondernemingFG.get('ondernemingen') as FormArray;
    }

    createOndernemingFormGroup(onderneming?: Onderneming) {
        return this.dataService.createOndernemingFormGroup(onderneming);
    }

    //niet aftrekbare kosten
    getNietAftrekbareKosten(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('nietAftrekbareKosten') as FormArray;
    }

    addNietAftrekbareKosten(index: number): void {
        const innerGroup = this.fb.group<JaarrekeningVenW>({
            omschrijving: '',
            bedrag: undefined,
        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('nietAftrekbareKosten') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteNietAftrekbareKosten(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getNietAftrekbareKosten(outerIndex);
        innerArray.removeAt(innerIndex);
        this.ondernemingFG.updateValueAndValidity()
        this.ondernemingFG.markAsDirty();
        this.saveForm()
    }

    //beperkt aftrekbare kosten
    getBeperktAftrekbareKosten(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('beperktAftrekbareKosten') as FormArray;
    }

    addBeperktAftrekbareKosten(index: number): void {
        const innerGroup = this.fb.group<JaarrekeningVenW>({
            omschrijving: '',
            bedrag: undefined,
        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('beperktAftrekbareKosten') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteBeperktAftrekbareKosten(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getBeperktAftrekbareKosten(outerIndex);
        innerArray.removeAt(innerIndex);
        this.ondernemingFG.updateValueAndValidity()
        this.ondernemingFG.markAsDirty();
        this.saveForm()
    }

    //vrijgestelde winst
    getVrijgesteldeWinst(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('wuoVrijgesteldeWinstbestanddelen') as FormArray;
    }

    addVrijgesteldeWinst(index: number): void {
        const innerGroup = this.fb.group<JaarrekeningVenW>({
            omschrijving: '',
            bedrag: undefined,
        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('wuoVrijgesteldeWinstbestanddelen') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteVrijgesteldeWinst(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getVrijgesteldeWinst(outerIndex);
        innerArray.removeAt(innerIndex);
        this.ondernemingFG.updateValueAndValidity()
        this.ondernemingFG.markAsDirty();
        this.saveForm()
    }

    public createOmschrijvingEnBedragFormGroup(ommschrijvingEnBedrag?: OmschrijvingEnBedrag): OmschrijvingEnBedrag {
        return this.fb.group(({
            omschrijving: ommschrijvingEnBedrag ? ommschrijvingEnBedrag.omschrijving : undefined,
            bedrag: ommschrijvingEnBedrag ? ommschrijvingEnBedrag.bedrag : undefined,
        } as OmschrijvingEnBedrag))
    }

    public createJaarrekeningVenWFormGroup(ommschrijvingEnBedrag?: JaarrekeningVenW): JaarrekeningVenW {
        return this.fb.group(({
            omschrijving: ommschrijvingEnBedrag ? ommschrijvingEnBedrag.omschrijving : undefined,
            bedrag: ommschrijvingEnBedrag ? ommschrijvingEnBedrag.bedrag : undefined,
        } as JaarrekeningVenW))
    }

    formStructure: any;
    ondernemingLength: any

    get specificatieJaarrekening(): FormArray {
        return this.specJaarrekeningFg.get('specificatieJaarrekening') as FormArray;
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.updateForm();
                });
                this.ondernemingFG.valueChanges.subscribe(value => {
                    this.formStructure = value;
                });
                this.ondernemingen.valueChanges.subscribe(value => {
                    this.ondernemingLength = value
                });
                this.dataService.winstResultatenrekening.subscribe(value => {
                    this.winstResultatenrekeningFg.patchValue({ winstResultatenrekening: value });
                });
            }
        });
        this.dataService.winstResultatenrekening.subscribe(value => {
            this.winstResultatenrekening = value;
            this.winstResultatenrekeningFg.patchValue({ winstResultatenrekening: value });
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
      if (this.isDefAangifteSubscription) {
          this.isDefAangifteSubscription.unsubscribe();
      }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.ondernemingFG.dirty
  }


  private updateForm(): void {
        let ondernemingenLijst = this.aangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                ondernemingenLijst = this.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
            }
        });

        const formArray = this.ondernemingFG.get('ondernemingen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > ondernemingenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Update ondernemingen
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(ondernemingenLijst[i]);
            } else {
                const formGroup = this.createOndernemingFormGroup(ondernemingenLijst[i])
                formArray.push(formGroup);
            }
        }

        // Update niet aftrekbare kosten array elke onderneming (z)
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            let onderneming = ondernemingenLijst[i];
            this.partner.subscribe((partner) => {
                if (partner) {
                    onderneming = ondernemingenLijst[i];
                }
            });

            const nietAftrekbareKosten = onderneming.nietAftrekbareKosten || [];
            const nietAftrekbareKostenFormArray = this.getNietAftrekbareKosten(i);

            while (nietAftrekbareKostenFormArray.length > nietAftrekbareKosten.length) {
                nietAftrekbareKostenFormArray.removeAt(nietAftrekbareKostenFormArray.length - 1);
            }
            for (let z = 0; z < nietAftrekbareKosten.length; z++) {
                if (z < nietAftrekbareKostenFormArray.length) {
                    const control = nietAftrekbareKostenFormArray.at(z) as FormGroup;
                    control.patchValue(nietAftrekbareKosten[z]);
                } else {
                    const nietAftrekbaarKosten = this.createOmschrijvingEnBedragFormGroup(nietAftrekbareKosten[z]);
                    nietAftrekbareKostenFormArray.push(nietAftrekbaarKosten);
                }
            }
        }

        // Update beperkt aftrekbare kosten array elke onderneming (p)
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            let onderneming = ondernemingenLijst[i];
            this.partner.subscribe((partner) => {
                if (partner) {
                    onderneming = ondernemingenLijst[i];
                }
            });

            const beperktAftrekbareKosten = onderneming.beperktAftrekbareKosten || [];
            const beperktAftrekbareKostenFormArray = this.getBeperktAftrekbareKosten(i);

            while (beperktAftrekbareKostenFormArray.length > beperktAftrekbareKosten.length) {
                beperktAftrekbareKostenFormArray.removeAt(beperktAftrekbareKostenFormArray.length - 1);
            }
            for (let p = 0; p < beperktAftrekbareKosten.length; p++) {
                if (p < beperktAftrekbareKostenFormArray.length) {
                    const control = beperktAftrekbareKostenFormArray.at(p) as FormGroup;
                    control.patchValue(beperktAftrekbareKosten[p]);
                } else {
                    const beperktAftrekbaarKosten = this.createOmschrijvingEnBedragFormGroup(beperktAftrekbareKosten[p]);
                    beperktAftrekbareKostenFormArray.push(beperktAftrekbaarKosten);
                }
            }
        }

        // Update vrijgestelde winst array elke onderneming (v)
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            let onderneming = ondernemingenLijst[i];
            this.partner.subscribe((partner) => {
                if (partner) {
                    onderneming = ondernemingenLijst[i];
                }
            });

            const wuoVrijgesteldeWinstbestanddelen = onderneming.wuoVrijgesteldeWinstbestanddelen || [];
            const wuoVrijgesteldeWinstbestanddelenFormArray = this.getVrijgesteldeWinst(i);

            while (wuoVrijgesteldeWinstbestanddelenFormArray.length > wuoVrijgesteldeWinstbestanddelen.length) {
                wuoVrijgesteldeWinstbestanddelenFormArray.removeAt(wuoVrijgesteldeWinstbestanddelenFormArray.length - 1);
            }
            for (let v = 0; v < wuoVrijgesteldeWinstbestanddelen.length; v++) {
                if (v < wuoVrijgesteldeWinstbestanddelenFormArray.length) {
                    const control = wuoVrijgesteldeWinstbestanddelenFormArray.at(v) as FormGroup;
                    control.patchValue(wuoVrijgesteldeWinstbestanddelen[v]);
                } else {
                    const vrijgesteldeWinst = this.createJaarrekeningVenWFormGroup(wuoVrijgesteldeWinstbestanddelen[v]);
                    wuoVrijgesteldeWinstbestanddelenFormArray.push(vrijgesteldeWinst);
                }
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }

    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    winstUitOnderneming: {
                        ...this.aangifte.box1?.winstUitOnderneming,
                        ondernemingen: this.ondernemingFG.value.ondernemingen
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        winstUitOnderneming: {
                            ...this.aangifte.partnerAangifte?.box1?.winstUitOnderneming,
                            ondernemingen: this.ondernemingFG.value.ondernemingen
                        }
                    }
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
    }

    public heeftOndernemingen(): boolean {
        if (this.partnerBoolean) {
            return !!(this.aangifte &&
                this.aangifte.partnerAangifte &&
                this.aangifte.partnerAangifte.box1 &&
                this.aangifte.partnerAangifte.box1.winstUitOnderneming &&
                this.aangifte.partnerAangifte.box1.winstUitOnderneming.ondernemingen &&
                this.aangifte.partnerAangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        } else {
            return !!(this.aangifte &&
                this.aangifte.box1 &&
                this.aangifte.box1.winstUitOnderneming &&
                this.aangifte.box1.winstUitOnderneming.ondernemingen &&
                this.aangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        }
    }
}


